import React, { useEffect } from "react";
import { useFormikContext } from "formik";

type MembershipPlan = {
  id: string;
  name: string;
  description?: string;
};

interface Props {
  plans: MembershipPlan[];
  selectedPlanId: string;
  onPlanSelect: (id: string) => void;
}

interface FormValues {
  selectedPlanId: string;
}

const SelectMembershipPlan = ({
  plans,
  selectedPlanId,
  onPlanSelect,
}: Props) => {
  const { setFieldValue, values } = useFormikContext<FormValues>();

  useEffect(() => {
    if (!values.selectedPlanId && plans.length === 1) {
      const singlePlan = plans[0].id;
      setFieldValue("selectedPlanId", singlePlan);
      onPlanSelect(singlePlan);
    }
  }, [plans, setFieldValue, values.selectedPlanId, onPlanSelect]);

  if (plans.length === 0) {
    return null;
  }

  return (
    <div className="shadow rounded p-4 bg-white">
      <h2 className="fs-16 mb-2">Selecciona el plan a asignar</h2>
      <div className="d-flex flex-column gap-2">
        {plans.map((plan) => (
          <label
            key={plan.id}
            className={`border rounded p-3 d-flex justify-content-between align-items-center ${
              selectedPlanId === plan.id ? "border-primary" : "border-secondary"
            }`}
          >
            <div>
              <h3 className="fs-14 fw-bold mb-1">{plan.name}</h3>
              {plan.description && (
                <p className="m-0 text-muted fs-12">{plan.description}</p>
              )}
            </div>
            <input
              type="radio"
              name="selectedPlanId"
              value={plan.id}
              checked={selectedPlanId === plan.id}
              onChange={() => {
                setFieldValue("selectedPlanId", plan.id);
                onPlanSelect(plan.id);
              }}
            />
          </label>
        ))}
      </div>
    </div>
  );
};

export default SelectMembershipPlan;
